
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import { CartProvider } from "./contexts/CartContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CartProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppRoutes />
          <BackToTop />
        </BrowserRouter>
      </CartProvider>
    </I18nextProvider>
  );
}

export default App;
